<div class="form-group">
  <button (click)="loginTM()" class="btn btn-tm btn-block login-button font-size-14 rounded-4">
    Login with <img class="ms-2" src="assets/images/ticketmaster.svg" draggable="false" />
  </button>
</div>

<div class="login-title-section mb-2">
  <fgbcl-errors></fgbcl-errors>
</div>
